import { useLanguage } from "@/i18n/LanguageContext";
import { TrendingUp, Gauge, TimerReset, Zap, FileSpreadsheet, Brain } from "lucide-react";

const metrics = [
  { icon: TrendingUp, value: "+5–20%", label: "Output Volume", text: "Identify hidden losses, micro-stops and capacity gaps." },
  { icon: Gauge, value: "+10–20%", label: "OEE", text: "Improve availability, performance and quality with real-time facts." },
  { icon: TimerReset, value: "-20–30%", label: "Unplanned Downtime", text: "React faster with downtime reasons, alerts and maintenance workflows." },
  { icon: Zap, value: "Better", label: "Energy Efficiency", text: "Track energy per machine, order, batch, meter, kilogram or product." },
  { icon: FileSpreadsheet, value: "Less", label: "Manual Work", text: "Replace paper reports with operator tablets, QR labels and automatic dashboards." },
  { icon: Brain, value: "Faster", label: "Decisions", text: "Give managers, supervisors and operators one source of production truth." },
];

export default function BusinessResultStrip() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Business results")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Factory visibility that turns into measurable business results.")}</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {metrics.map((m) => (
            <div key={m.label} className="rounded-lg border border-border bg-card p-5 hover-glow">
              <m.icon className="h-6 w-6 text-primary mb-3" />
              <div className="text-3xl font-bold font-heading mb-1">{t(m.value)}</div>
              <div className="text-sm font-semibold mb-2">{t(m.label)}</div>
              <p className="text-sm text-muted-foreground">{t(m.text)}</p>
            </div>
          ))}
        </div>
        <p className="mt-6 text-xs text-muted-foreground max-w-2xl">
          {t("Typical improvement potential depends on current baseline, production process, and adoption level.")}
        </p>
      </div>
    </section>
  );
}